<template>
  <div class="flex justify-center">
    <div class="max-w-[32rem] w-full flex flex-col items-start justify-center gap-y-1">
      <div class="stepper w-full flex justify-center items-center">
        <div
          :key="key"
          v-for="(_, key) in steps"
          class="stepper__step w-3/12 flex justify-center items-center"
        >
          <div
            :class="{ 'border border-brand-gray-600': key > 0 && key < steps.length }"
            class="flex-1"
          ></div>

          <component
            :is="disabled ? 'div' : 'button'"
            class="flex justify-center"
            @click="!disabled && $emit('onStepClick', key)"
          >
            <div
              :class="[stepNumberClass(key), stepFillClass(key), stepBorderClass(key)]"
              class="flex items-center justify-center w-10 h-10 rounded-full text-lg"
            >
              {{ key + 1 }}
            </div>
          </component>
          <div
            :class="{ 'border border-brand-gray-600': key >= 0 && key < steps.length - 1 }"
            class="flex-1"
          ></div>
        </div>
      </div>
      <div class="stepper w-full flex justify-center items-center">
        <div
          :key="key"
          v-for="(step, key) in steps"
          class="stepper__step w-3/12 flex justify-center items-center"
        >
          <div class="flex justify-center">
            <component
              :is="disabled ? 'div' : 'button'"
              :class="[stepLabelClass(key)]"
              class="flex items-center justify-center text-sm text-center"
              @click="!disabled && $emit('onStepClick', key)"
            >
              {{ $t(step) }}
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFormStore } from '@/stores/form'
defineProps({
  steps: {
    type: Array,
    required: true
  },
  disabled: { type: Boolean, default: () => false }
})

const formStore = useFormStore()

defineEmits('onStepClick')

const stepNumberClass = (key) => {
  if (formStore.activeStepIndex === key) {
    return 'text-primary'
  }

  if (formStore.activeStepIndex > key) {
    return 'text-white'
  }

  return 'text-brand-gray-600'
}

const stepFillClass = (key) => {
  if (formStore.activeStepIndex > key) {
    return 'bg-primary'
  }

  return null
}

const stepBorderClass = (key) => {
  if (formStore.activeStepIndex === key) {
    return 'border border-primary'
  }

  if (formStore.activeStepIndex > key) {
    return 'border border-primary'
  }

  return 'border border-brand-gray-600'
}

const stepLabelClass = (key) => {
  if (formStore.activeStepIndex === key) {
    return 'text-black/70'
  }

  if (formStore.activeStepIndex > key) {
    return 'text-primary'
  }

  return 'text-brand-gray-600'
}
</script>

<style lang="scss" scoped></style>
